import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './Title.scss';
function Title(props) {
    return <View className="comprehensive-card-title-container">
      <Text className="comprehensive-card-title-style" numberOfLines={2}>
        {props.title}
      </Text>
    </View>;
}
export default memo(Title);
